window.setupStateCitySelect = function (stateSelect, citySelect, cityEndpoint) {

    if (stateSelect && citySelect && !stateSelect.is('[readonly]') && !citySelect.is('[readonly]')) {
        stateSelect.select2();

        citySelect.select2({
            ajax: {
                url: cityEndpoint,
                data: function (params) {
                    return {
                        search: params.term,
                        state_id: stateSelect.val()
                    };
                },
                dataType: 'json',
            },
            minimumInputLength: 3
        });

        function onStateSelected(state_id) {
            citySelect.val('').trigger('change');
            if (state_id) {
                citySelect.attr('disabled', null);
                citySelect.trigger({
                    type: 'select2:select',
                    params: {
                        data: { id: '' }
                    }
                });
            } else {
                citySelect.attr('disabled', 'disabled');
            }
        }

        stateSelect.on('select2:select', function () {
            onStateSelected($(this).val());
        });

        if (!stateSelect.val()) {
            onStateSelected(stateSelect.val());
        }
    }

}
